import React from 'react';
import './LandingPage.css';

export default function AddElectors() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Add Electors</h1>
      <p>Form/page to add electors (placeholder).</p>
    </main>
  );
}
